<template lang="">
      <div :class="['app-create-new-ai-content__section--review-details app-create-new-ai-content__section', subScreen === 'review' ? '':'hidden']">
        <div class="app-create-new-ai-content__section-header">
          <h4 class="app-create-new-ai-content__section-title">Review Details</h4>
          <p class="app-create-new-ai-content__section-instructions">Look over the final details before generating your video script</p>
        </div>
        <div>
          <div class="app-create-new-ai-content__section-body grid">
            <div class="col-12">
              <div class="input text">
                <label for="name">Title</label>
                <input type="text" class="form-control" name="name" id="name" v-model="videoScript.name" disabled>
              </div>
            </div>
            <div class="col-12">
              <div class="input text">
                <label for="name">Description</label>
                <textarea rows="8" name="input_description" v-model="videoScript.ai_preferences.input_description" disabled></textarea>
              </div>
            </div>
            <div class="col-12">
              <div class="input text">
                <label for="name">Duration</label>
                <input type="text" name="input_duration"v-model="videoScript.ai_preferences.input_duration" disabled>
                <p class="inline-message">Please note that this is an approximation, and the AI-generated script may not perfectly match the specified duration.</p>
              </div>
            </div>
            <div class="col-12">
              <div class="input text">
                <label for="name">Video Structure</label>
                <textarea rows="8" name="input_structure" v-model="videoScript.ai_preferences.input_structure" disabled></textarea>
              </div>
            </div>
            <div class="col-12">
              <label for="name" class="checkbox__group-label">Golden Source</label>
              <div v-for="topic in selectedTopics" :key="topic.uuid" class="checkbox">
                <label>
                  <input type="checkbox" disabled checked>
                  {{ topicByUUID(topic) }}
                </label>
              </div>
            </div>
          </div>
          <div class="app-create-new-ai-content__section-footer">
            <app-button theme="secondary" @click="setSubscreen('topics')">
              Back
            </app-button>
            <app-button theme="ai-primary"
              type="submit"
              class=""
              :disabled="disabledButton || !prerequisitesMet"
              @click="$emit('submit')">
              <svg class="element-icon--ai element-icon" width="1em" height="1em"><use href="/img/icons.svg#icon-ai"></use></svg>
              {{ disabledButton ? 'Processing...' : 'Generate Video Script' }}
            </app-button>
          </div>
        </div>
      </div>
</template>
<script>
export default {
    name: 'VideoScriptAppFinalReview',
    props: {
        topics: {
            type: Array,
            default: () => ([])
        },
        videoScript: {
            type: Object,
            required: true
        },
        disabledButton: {
            type: Boolean,
            required: false,
            default: false
        },
        selectedTopics: {
            type: Array,
            default: () => ([])
        },
        subScreen: {
            type: String,
            required: true
        }
    },
    computed: {
        prerequisitesMet () {
            return true
        },
    },
    methods: {
        topicByUUID(uuid) {
        for (const domain of this.topics) {
            const topic = domain.topics.find(topic => topic.uuid === uuid)
            if (topic) return topic.name
        }
        return null
        }
    }
}
</script>
